<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container">
    <div class="left-container">
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Basic Information
        </div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" required [readonly]="!isCreateMode">
            </mat-form-field>
          </div>
          <div class="form-field-container" *ngIf="isCreateMode">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Password</mat-label>
              <input matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'" required>
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!hidePassword">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="form-field-container" *ngIf="isCreateMode">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Confirm Password</mat-label>
              <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'" required>
              <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!hideConfirmPassword">
                <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Full Name</mat-label>
              <input matInput formControlName="fullName" required>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-checkbox formControlName="active">Active</mat-checkbox>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Contact Information
        </div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Primary Phone</mat-label>
              <input matInput formControlName="contactPhone1" required>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Secondary Phone</mat-label>
              <input matInput formControlName="contactPhone2">
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Communications Manager</mat-label>
              <input matInput formControlName="communicationsManager">
            </mat-form-field>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Access Configuration
        </div>
        <div class="section-content">
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Access Start Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker" formControlName="accessStartDate">
              <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Access End Date</mat-label>
              <input matInput [matDatepicker]="endDatePicker" formControlName="accessEndDate">
              <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container">
          <mat-checkbox formControlName="canAccessDirectors">Can Access Directors</mat-checkbox>
        </div>
        <div class="form-field-container">
          <mat-checkbox formControlName="isInternal">Internal user</mat-checkbox>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Ip Ranges
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Ip from</mat-label>
                <input matInput placeholder="e.g. 192.168.1.1" [(ngModel)]="ipFrom" [ngModelOptions]="{standalone: true}"
                       (keydown.enter)="$event.preventDefault(); addIpRange()">
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-field">
                <mat-label>Ip to (optional)</mat-label>
                <input matInput placeholder="Leave empty for a single address" [(ngModel)]="ipTo" [ngModelOptions]="{standalone: true}"
                       (keydown.enter)="$event.preventDefault(); addIpRange()">
              </mat-form-field>
              <button mat-icon-button type="button" (click)="addIpRange()" matTooltip="Add Ip Range">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          @if (ipRanges.length > 0) {
            <table mat-table [dataSource]="ipRanges" class="ip-range-table">
              <ng-container matColumnDef="start">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let range; let i = index">
                  @if (isEditingIpRange(i)) {
                    <mat-form-field appearance="fill" class="edit-field">
                      <input matInput [(ngModel)]="editIpFrom" [ngModelOptions]="{standalone: true}"
                             (keydown.enter)="$event.preventDefault(); saveIpRangeEdit()"
                             (keydown.escape)="cancelIpRangeEdit()" #editIpFromInput>
                    </mat-form-field>
                  } @else {
                    {{ range.start }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="end">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let range; let i = index">
                  @if (isEditingIpRange(i)) {
                    <mat-form-field appearance="fill" class="edit-field">
                      <input matInput [(ngModel)]="editIpTo" [ngModelOptions]="{standalone: true}"
                             placeholder="Single address"
                             (keydown.enter)="$event.preventDefault(); saveIpRangeEdit()"
                             (keydown.escape)="cancelIpRangeEdit()">
                    </mat-form-field>
                  } @else if (range.end === range.start) {
                    <span class="single-address">single address</span>
                  } @else {
                    {{ range.end }}
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let range; let i = index" class="actions-cell">
                  @if (isEditingIpRange(i)) {
                    <button mat-icon-button type="button" (click)="saveIpRangeEdit()" matTooltip="Save">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="cancelIpRangeEdit()" matTooltip="Cancel">
                      <mat-icon>close</mat-icon>
                    </button>
                  } @else {
                    <button mat-icon-button type="button" (click)="startIpRangeEdit(i)" matTooltip="Edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="removeIpRange(i)" matTooltip="Remove">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="ipRangeColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: ipRangeColumns"></tr>
            </table>
          } @else {
            <div class="empty-hint">No IP restriction — the customer can sign in from any address.</div>
          }
        </div>
      </section>
    </div>

    <div class="right-container">
      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Countries
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select formControlName="countries" placeholder="Select Countries" multiple>
                  <mat-option *ngFor="let country of countries$ | async" [value]="country.id">
                    {{ country.name }}
                  </mat-option>
                  <mat-select-trigger>
                    <ng-container *ngIf="form.get('countries')?.value as selected">
                      {{selected[0] ? getCountryName(selected[0]) : ''}}
                      <span *ngIf="selected.length > 1" class="additional-count">
                        +{{selected.length - 1}} more
                      </span>
                    </ng-container>
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="selectAllCountries()" matTooltip="Select all countries">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllCountries()" matTooltip="Deselect all countries">
                <mat-icon>deselect</mat-icon>
              </button>
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected countries">
              <mat-chip class="chip-basic-item" *ngFor="let countryId of form.get('countries')?.value">
                {{ getCountryName(countryId) }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Industries
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select formControlName="industries" placeholder="Select Industries" multiple>
                  <mat-option *ngFor="let industry of industries$ | async" [value]="industry.id">
                    {{ industry.name }}
                  </mat-option>
                  <mat-select-trigger>
                    <ng-container *ngIf="form.get('industries')?.value as selected">
                      {{selected[0] ? getIndustryName(selected[0]) : ''}}
                      <span *ngIf="selected.length > 1" class="additional-count">
                        +{{selected.length - 1}} more
                      </span>
                    </ng-container>
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="selectAllIndustries()" matTooltip="Select all industries">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllIndustries()" matTooltip="Deselect all industries">
                <mat-icon>deselect</mat-icon>
              </button>
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected industries">
              <mat-chip class="chip-basic-item" *ngFor="let industryId of sortedSelectedIndustryIds">
                {{ getIndustryName(industryId) }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Companies
        </div>
        <div class="section-content">
          <div class="section-field">
            <button mat-flat-button color="primary" type="button" (click)="openCompaniesDialog()" class="open-companies-button">
              <mat-icon>business</mat-icon>
              Select Companies
            </button>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected companies">
              <mat-chip class="chip-basic-item" *ngFor="let companyId of form.get('companies')?.value">
                {{ getCompanyName(companyId) }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Report Variables
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select formControlName="reportVariables" placeholder="Select Report Variables" multiple>
                  <mat-option *ngFor="let category of reportVariableCategories" [value]="category.id">
                    {{ category.name }}
                  </mat-option>
                  <mat-select-trigger>
                    <ng-container *ngIf="form.get('reportVariables')?.value as selected">
                      {{selected[0] ? getReportVariableName(selected[0]) : ''}}
                      <span *ngIf="selected.length > 1" class="additional-count">
                        +{{selected.length - 1}} more
                      </span>
                    </ng-container>
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="selectAllReportVariables()" matTooltip="Select all report variables">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllReportVariables()" matTooltip="Deselect all report variables">
                <mat-icon>deselect</mat-icon>
              </button>
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected report variables">
              <mat-chip class="chip-basic-item" *ngFor="let reportVariable of form.get('reportVariables')?.value">
                {{ getReportVariableName(reportVariable) }}
              </mat-chip>
            </mat-chip-set>
          </div>
        </div>
      </section>

      <section class="section-container nrg-border-radius">
        <div class="section-header">
          Measurements
        </div>
        <div class="section-content">
          <div class="section-field">
            <div class="select-with-button">
              <mat-form-field appearance="fill" class="form-field">
                <mat-select formControlName="selectedMeasurements" placeholder="Select Measurements" multiple [compareWith]="compareMeasurements">
                  @for (measurement of measurements; track measurement) {
                    <mat-option [value]="measurement">
                      {{ measurement }}
                    </mat-option>
                  }
                  <mat-select-trigger>
                    @if (form.get('selectedMeasurements')?.value; as selected) {
                      {{selected[0] ? getMeasurementName(selected[0]) : ''}}
                      @if (selected.length > 1) {
                        <span class="additional-count">
                          +{{selected.length - 1}} more
                        </span>
                      }
                    }
                  </mat-select-trigger>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button type="button" (click)="selectAllMeasurements()" matTooltip="Select all measurements">
                <mat-icon>select_all</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="deselectAllMeasurements()" matTooltip="Deselect all measurements">
                <mat-icon>deselect</mat-icon>
              </button>
            </div>
          </div>
          <div class="section-selections">
            <mat-chip-set aria-label="Selected measurements">
              @for (measurementId of getSelectedMeasurementsArray(); track measurementId) {
                <mat-chip class="chip-basic-item">
                  {{ getMeasurementName(measurementId) }}
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div class="form-actions">
    <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="!form.valid">
      <mat-icon>save</mat-icon>
      {{ submitButtonText }}
    </button>
    <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
  </div>
</form>
